// extracted by mini-css-extract-plugin
module.exports = {"svg":"modal-1-pie-1-module--svg--iSL8e"};